<template>
  <div class="popup-header-tool">
    <div class="empty"></div>
    <div class="title">{{title}}</div>
    <img @click="close" class="close-btn" src="../../assets/img/public/popup_close.png" alt="关闭">
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.popup-header-tool{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 72px);
  height: 100px;
  margin: 0 36px;

  .title{
    color: #333;
    font-weight: 600;
    font-size: 33px;
    line-height: 45px;
  }

  .empty,img{
    width: 30px;
  }
}
</style>
